/**
 * © [2023] Conduent, Inc. All rights reserved. Conduent®and Conduent Agile
 * Star®are trademarks of Conduent, Inc. and/or its subsidiaries in the United
 * States and/or other countries.
 */
import MaxLengthNumericEditor from '../../../../../SharedModules/CustomAgGridEditor/inputComponent';
import * as Styles from '../../../../../SharedModules/StyleConstant/StyleConstant';

function monthToComparableNumber(date) {
  if (date === undefined || date === null || date.length !== 10) {
    return null;
  }

  const yearNumber = Number.parseInt(date.substring(6, 10));
  const dayNumber = Number.parseInt(date.substring(3, 5));
  const monthNumber = Number.parseInt(date.substring(0, 2));
  return yearNumber * 10000 + monthNumber * 100 + dayNumber;
}
function dateComparator(date1, date2) {
  const date1Number = monthToComparableNumber(date1);
  const date2Number = monthToComparableNumber(date2);

  if (date1Number === null && date2Number === null) {
    return 0;
  }
  if (date1Number === null) {
    return -1;
  }
  if (date2Number === null) {
    return 1;
  }

  return date1Number - date2Number;
}
export const coverageGapHead = [
  {
    headerName: 'Actions',
    field: 'actionVal',
    hideFilterIcon: true,
    editable: false,
    sortable: false,
    filter: false,
    suppressMenu: false,
    minWidth: Styles.Width_200,
    cellEditor: MaxLengthNumericEditor,
    cellClass: 'ag-cell-action',
    cellEditorPopup: true,
    cellRenderer: 'ActionCellRender',
    cellStyle: { 'border-right-color': Styles.BorderColor },
  },
  {
    headerName: 'Start Date',
    field: 'startDate',
    comparator: dateComparator,
    cellRenderer: 'StartDate',
    editable: false,
    sortable: true,
    suppressMenu: false,
    minWidth: Styles.Width_300,
    cellEditor: MaxLengthNumericEditor,
    cellStyle: { 'border-right-color': Styles.BorderColor },
    sortingOrder: ['desc', 'asc'],
    filter: 'agTextColumnFilter',
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
  },
  {
    headerName: 'End Date',
    field: 'endDate',
    comparator: dateComparator,
    cellRenderer: 'EndDate',
    editable: false,
    sortable: true,
    suppressMenu: false,
    minWidth: Styles.Width_300,
    resizable: false,
    cellEditor: MaxLengthNumericEditor,
    cellStyle: { 'border-right-color': Styles.BorderColor },
    sortingOrder: ['desc', 'asc'],
    filter: 'agTextColumnFilter',
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
  },
];
